import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Table, Button, Pagination, PaginationItem, PaginationLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input, Alert, UncontrolledDropdown } from "reactstrap";
import axios from 'axios';
import { BASE_URL, USER_PERMISSIONS, checkPermission } from "../../../constants";

let apiTimeoutId = null;

function Property() {
	const [property, setProperty] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [perPage, setPerPage] = useState(5);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [searchQuery, setSearchQuery] = useState("");
	const [errMsg, setErrMsg] = useState(null);
	const navigate = useNavigate();
	const userData = JSON.parse(localStorage.getItem('userData'));
	// console.log(property, 'property')

	useEffect(() => {
		if (apiTimeoutId) clearTimeout(apiTimeoutId);

		apiTimeoutId = setTimeout(() => {
			fetchData();
		}, 500);
	}, [currentPage, perPage, searchQuery]);

	const toggleDropdown = () => {
		setDropdownOpen(prevState => !prevState);
	};

	const handleSearchInputChange = (event) => {
		setSearchQuery(event.target.value);
	};


	const fetchData = () => {
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/property/list?page_no=${currentPage}&per_page=${perPage}&q=${searchQuery}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					console.log(data, 'data');
					if (data.status) {
						const formattedProperties = data.result.data.map(property => {
							const formattedProperty = { ...property };
							formattedProperty.created_at = new Date(property.created_at).toLocaleDateString('en-US');
							return formattedProperty;
						});
						setProperty(formattedProperties);
						setTotalPages(data.result.meta_info.total_pages);
					} else {
						console.error("Error: Unable to fetch property data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	};


	const handleAddProperty = () => {
		console.log("Add property clicked");
		navigate('/property/add')
	};

	const handlePageClick = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const handlePerPageChange = (value) => {
		setPerPage(value);
		setCurrentPage(1);
	};

	const handleViewTimeline = async (id) => {
		navigate(`/property/timeline/${id}`, {
			state: {
				property: property
			}
		});
	};

	const handleEditProperty = (id) => {
		navigate(`/property/edit/${id}`, {
			state: {
				property: property
			}
		});
	};

	const handleDeleteProperty = async (id) => {
		if (window.confirm("Are you sure you want to delete this property?")) {
			const token = localStorage.getItem('token');
			if (token) {
				const response = await axios.delete(`${BASE_URL}/property/delete/${id}`, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				});
	
				console.log(response, 'response');
	
				fetchData();
			}
		}
	}


	return (
		<div className="content">
			{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

			<Row>
				<Col xs="6">
					<h4 className="mt-0">Properties</h4>
				</Col>

				<Col xs="6" className="text-end">
					{(checkPermission(USER_PERMISSIONS.ADD_PROPERTY)) ? (
					<Button color="primary" onClick={handleAddProperty}>Add Property</Button>
					) : null}
				</Col>
			</Row>

			<Card>
				<CardBody>

					<Row className="my-3">
						<Col xs="12" className="text-end">
							<Input
								type="text"
								placeholder="Search by name"
								value={searchQuery}
								onChange={handleSearchInputChange}
								style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
							/>
							{/* <Button color="primary" onClick={handleSearch}>Search</Button> */}
						</Col>
					</Row>

					<div>
						<Table>
							<thead>
								<tr>
									<th>#</th>
									<th>Cover Image</th>
									<th>TYPE</th>
									<th>Name</th>
									<th>Location</th>
									<th>City</th>
									<th>State</th>
									<th>Country</th>
									<th>Created at</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								{(property.length === 0) ? (
									<tr>
										<td colSpan="10" className="text-center">
											No properties available.
										</td>
									</tr>
								) : null}
								{property.map((property, index) => (
									<tr key={index}>
										<td>{(currentPage - 1) * perPage + index + 1}</td>
										<td>
											{property.cover_image && (
												<img src={property.cover_image} alt="cover" style={{ width: '60px', height: 'auto' }} />
											)
											}
										</td>
										<td>{property.type}</td>
										<td><strong>{property.name}</strong></td>
										<td>{property.location}</td>
										<td>{property.city}</td>
										<td>{property.state}</td>
										<td>{property.country}</td>
										<td>{property.created_at}</td>
										<td>
											<UncontrolledDropdown>
												<DropdownToggle
													caret
													color="primary"
												>
													Action
												</DropdownToggle>
												<DropdownMenu>
													{(checkPermission(USER_PERMISSIONS.UPDATE_PROPERTY) || (userData.type == "MANAGER" && property.created_by == userData.id)) ? (
													<DropdownItem onClick={() => handleEditProperty(property.id)}>
														Edit
													</DropdownItem>
													) : null}
													<DropdownItem onClick={() => handleViewTimeline(property.id)}>
														View Timeline
													</DropdownItem>
													<DropdownItem onClick={() => {
														navigate(`/inspection?property=${property.id}`);
													}}>
														View Inspections
													</DropdownItem>
													{(userData.type == "OWNER" || (userData.type == "MANAGER" && property.created_by == userData.id)) ? (
													<DropdownItem onClick={() => handleDeleteProperty(property.id)}>
														Delete
													</DropdownItem>
													) : null}
												</DropdownMenu>
											</UncontrolledDropdown>
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					</div>


				</CardBody>
				<Row>
					<Col xs="4">

						<div style={{ marginLeft: '25px' }}>
							<Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
								<DropdownToggle caret color="primary">
									Per Page: {perPage}
								</DropdownToggle>
								<DropdownMenu>
									<DropdownItem onClick={() => handlePerPageChange(5)}>5</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(10)}>10</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(20)}>20</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(50)}>50</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</div>
					</Col>

					<Col xs="8" className="text-right">
						<div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', marginRight: '25px', marginTop: '10px' }}>
							<Pagination aria-label="Page navigation example">
								<PaginationItem disabled={currentPage === 1}>
									<PaginationLink
										previous
										onClick={() => handlePageClick(currentPage - 1)}
									/>
								</PaginationItem>
								{currentPage > 3 && (
									<>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(1)}>
												1
											</PaginationLink>
										</PaginationItem>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
									</>
								)}
								{Array.from({ length: 5 }, (_, i) => {
									const page = currentPage <= 3 ? i + 1 : currentPage - 2 + i;
									return (
										page <= totalPages && (
											<PaginationItem key={page} active={currentPage === page}>
												<PaginationLink
													onClick={() => handlePageClick(page)}
												>
													{page}
												</PaginationLink>
											</PaginationItem>
										)
									);
								})}

								{currentPage < totalPages - 2 && (
									<>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(totalPages)}>
												{totalPages}
											</PaginationLink>
										</PaginationItem>
									</>
								)}

								<PaginationItem disabled={currentPage === totalPages}>
									<PaginationLink
										next
										onClick={() => handlePageClick(currentPage + 1)}
									/>
								</PaginationItem>
							</Pagination>
						</div>
					</Col>
				</Row>

			</Card>

		</div>
	);
}

export default Property;
